'use strict';

import NotFound from './views/NotFound';
import Home from './views/Home';
import Login from './views/Login';
import Clients from './views/Clients';
import ClientsAdd from './views/ClientsAdd';
import ClientsDetail from './views/ClientsDetail';
import Contract from './views/Contract';
import Documents from './views/Documents';
import DocumentType from './views/DocumentType';
import Processes from './views/Processes';
import ProcessesDetail from './views/ProcessesDetail';
import Producers from './views/Producers';
import Companies from './views/Companies';
import CompaniesDetail from './views/CompaniesDetail';
import SheetCompanies from './views/SheetCompanies';
import SheetList from './views/SheetList';
import Sheet from './views/Sheet';
import Todo from './views/Todo';
import Gibi from './views/Gibi';
import UnlinkedContractsList from './views/UnlinkedContractsList';
import UnlinkedContractsDetail from './views/UnlinkedContractsDetail';
import api from './api/core';

function init(router) {
    // URLs ---
    router.map({
        '*': {
            component: NotFound
        },
        '/not-found': {
            component: NotFound,
            name: 'not-found'
        },
        '/': {
            component: Home,
            name: 'home',
            auth: true
        },
        '/login': {
            component: Login,
            name: 'login'
        },
        '/clients': {
            component: Clients,
            name: 'clients',
            auth: true
        },
        '/clients/add': {
            name: 'clients-add',
            component: ClientsAdd,
            auth: true
        },
        '/clients/:id': {
            name: 'clients-detail',
            component: ClientsDetail,
            auth: true
        },
        '/clients/:id/contracts/add': {
            name: 'contracts-add',
            component: Contract,
            auth: true
        },
        '/clients/:id/contracts/:contractId/document/:docName': {
            name: 'contracts-document-search',
            component: Contract,
            auth: true
        },
        '/clients/:id/contracts/:contractId': {
            name: 'contracts-edit',
            component: Contract,
            auth: true
        },
        '/document-types': {
            name: 'document-types',
            component: Documents,
            auth: true
        },
        '/document-types/add': {
            name: 'document-types-add',
            component: DocumentType,
            auth: true
        },
        '/document-types/:id': {
            name: 'document-types-edit',
            component: DocumentType,
            auth: true
        },
        '/processes': {
            name: 'processes',
            auth: true,
            component: Processes
        },
        '/processes/add': {
            name: 'processes-add',
            auth: true,
            component: ProcessesDetail
        },
        '/processes/:id': {
            name: 'processes-edit',
            auth: true,
            component: ProcessesDetail
        },
        '/producers': {
            name: 'producers',
            auth: true,
            component: Producers
        },
        '/companies': {
            name: 'companies',
            auth: true,
            component: Companies
        },
        '/companies/:id': {
            name: 'companies-detail',
            component: CompaniesDetail,
            auth: true
        },
        '/sheet': {
            name: 'sheet-list',
            auth: true,
            component: SheetList
        },
        '/sheet/add': {
            name: 'sheet-companies',
            auth: true,
            component: SheetCompanies
        },
        '/sheet/add/:company': {
            name: 'sheet-add',
            auth: true,
            component: Sheet
        },
        '/sheet/edit/:id': {
            name: 'sheet-edit',
            auth: true,
            component: Sheet
        },
        '/todo': {
            name: 'todo-list',
            auth: true,
            component: Todo
        },
        '/gibi': {
            name: 'gibi',
            auth: true,
            component: Gibi
        },
        '/unlinked-contracts': {
            name: 'unlinked-contracts',
            auth: true,
            component: UnlinkedContractsList
        },
        '/unlinked-contracts/:id': {
            name: 'unlinked-contracts-detail',
            component: UnlinkedContractsDetail,
            auth: true
        }
    });

    // Ensure users are logged in required pages ---
    router.beforeEach(function (transition) {
        if (transition.to.auth && !api.isAuthenticated()) {
            transition.redirect({name: 'login'});
            return;
        }
        if (transition.to.name === 'login' && api.isAuthenticated()) {
            transition.redirect({name: 'home'});
            return;
        }

        if (api.isAuthenticated() && !api.isStaff() && transition.to.auth) {
            const partnerCode = api.getPartnerCode();
            const PARTNER_ALLOWED = [
                'home',
                'clients', 'clients-add', 'clients-detail',
                'contracts-add', 'contracts-edit', 'contracts-document-search',
                'todo-list'
            ];

            if (!partnerCode) {
                // Non-staff without partner_code: no access at all
                transition.redirect({name: 'not-found'});
                return;
            }

            if (!PARTNER_ALLOWED.includes(transition.to.name)) {
                transition.redirect({name: 'not-found'});
                return;
            }
        }

        transition.next();
    });

    // Watch login status ---
    api.onAuthStatusChange(function (status) {
        if (!status) {
            router.go({name: 'login'});
        }
    });
}

export default {
    init
};



// WEBPACK FOOTER //
// ./src/urls.js